// Multivariate Dependencies
import React from 'react';
/**
 * @deprecated Do not use legacy components anymore.
 * @param LoaderAnimationProps
 * @returns {Element}
 */
var LoaderAnimation = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 50 : _b, _c = _a.absolute, absolute = _c === void 0 ? true : _c;
    var style = {
        width: "".concat(size, "px"),
    };
    if (absolute) {
        style.position = 'absolute';
        style.top = "calc(50% - ".concat(size / 2, "px)");
        style.left = "calc(50% - ".concat(size / 2, "px)");
    }
    return (React.createElement("div", { className: 'anim-loader', style: style },
        React.createElement("svg", { className: 'anim-loader-circular', viewBox: '25 25 50 50' },
            React.createElement("circle", { className: 'anim-loader-path', cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' }))));
};
export default LoaderAnimation;
//# sourceMappingURL=LoaderAnimation.js.map